import { PartialDeep } from '@utils/ts';

import { BASE_THEME } from './constants';
import { extendTheme } from './extendTheme';
import { Theme } from './interfaces';

export function createTheme(theme: PartialDeep<Theme>): Theme {
  return extendTheme(BASE_THEME, theme);
}
